import React from 'react';
import logo from '../assets/AUSM-LOGO.png';

const FinalPolicyPreview = ({ formData, handleBack, handleSubmit }) => {
    const today = new Date().toLocaleDateString('en-GB');

    return (
        <div className="bg-gray-100 min-h-screen py-10 print:p-0 print:bg-white">
            {/* Action Buttons (Hidden during Print) */}
            <div className="max-w-4xl mx-auto mb-6 flex justify-between print:hidden">
                <button 
                    onClick={handleBack}
                    className="bg-gray-500 text-white px-6 py-2 rounded-lg font-bold"
                >
                    Back to Form
                </button>
                <div className="flex gap-4">
                    <button 
                        onClick={() => window.print()}
                        className="bg-blue-600 text-white px-6 py-2 rounded-lg font-bold flex items-center gap-2"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/></svg>
                        Print as PDF
                    </button>
                    <button 
                        onClick={handleSubmit}
                        className="bg-[#b60041] text-white px-10 py-2 rounded-lg font-bold"
                    >
                        Confirm & Final Submit
                    </button>
                </div>
            </div>

            {/* THE DOCUMENT (PDF Style) */}
            <div className="max-w-[210mm] mx-auto bg-white shadow-2xl p-[15mm] text-right rtl font-sans text-xs leading-relaxed print:shadow-none print:p-0">
                
                {/* PAGE 1 HEADER */}
                <div className="flex justify-between items-start border-b-2 border-red-800 pb-4 mb-4">
                    <div className="text-left ltr">
                        <p className="text-blue-900 font-bold text-lg">American University for Medical Sciences</p>
                        <h1 className="text-blue-900 font-bold text-xl">الـجـامـعـة الامـريـكـيـة لـلـعـلـوم الـطـبـيـه</h1>
                    </div>
                    <img src={logo} alt="AUMS Logo" className="h-20" />
                </div>

                <div className="bg-gray-100 p-2 text-center mb-4">
                    <p className="font-bold text-sm">إقرار وتعهد بتسديد الرسوم الجامعية والإلتزام بسياسة الإسترداد في حالة القبول في الجامعة</p>
                    <p className="font-bold text-sm">للطلبة الدارسين على حسابهم الخاص فقط</p>
                </div>

                {/* Section 1 */}
                <p className="font-bold text-red-700 underline mb-2">أولاً : الرسوم والمبالغ (الغير قابلة للاسترداد) :</p>
                <div className="pr-4 mb-4">
                    <p>1- رسوم التقديم: 20 دينار كويتي (تدفع مرة واحدة)</p>
                    <p>2- رسوم اختبارات القبول: 5 دينار لكل اختبار (تدفع مرة واحدة)</p>
                    <p>3- رسوم التسجيل: 150 دينار كويتي (لكل فصل دراسي) وتخصم من الرسوم الدراسية المدفوعة للفصل الدراسي</p>
                    <p>4- مبلغ حجز المقعد الدراسي: 1500 دينار كويتي (يسدد مرة واحدة عند القبول، ويخصم من الرسوم الدراسية للفصل الدراسي الذي تم القبول فيه بالجامعة)</p>
                </div>

                {/* Section 2 */}
                <p className="font-bold text-red-700 underline mb-2">ثانياً : الرسوم الدراسية:</p>
                <div className="pr-4 mb-4 text-justify">
                    <p>- عند الترشيح للقبول في الجامعة ، يلتزم الطالب بسداد مبلغ حجز المقعد الدراسي (غير قابل للاسترداد)، بالإضافة إلى كامل رسوم الفصل الدراسي الذي تم القبول فيه بالجامعة ، وذلك قبل إرسال رسالة القبول عبر البريد الإلكتروني. وفي حال عدم الالتزام بالسداد خلال المدة المحددة والمذكورة في البلاغ، يعد الترشيح ملغياً تلقائياً دون الحاجة إلى إشعار أو إنذار مسبق.</p>
                    <p>- للفصول الدراسية المتتالية: يجب دفع الرسوم الدراسية بالكامل قبل أول يوم دراسي لذلك الفصل لاستكمال التسجيل.</p>
                </div>

                <p className="font-bold mb-2">بكالوريوس طب الأسنان:</p>
                <table className="w-full border-collapse border border-black mb-4 text-center">
                    <thead>
                        <tr className="bg-teal-700 text-white font-bold">
                            <th className="border border-black p-1">الحد الادنى لعدد سنوات الدراسة</th>
                            <th className="border border-black p-1">الرسوم الدراسية</th>
                            <th className="border border-black p-1">الحد الأدنى لعدد الساعات المعتمدة المطلوبة للتخرج</th>
                            <th className="border border-black p-1">المعدل المطلوب للتخرج</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border border-black p-1">6 سنوات</td>
                            <td className="border border-black p-1">360 دينار كويتي لكل ساعة معتمدة *</td>
                            <td className="border border-black p-1">215</td>
                            <td className="border border-black p-1">معدل تراكمي (CGPA) لا يقل عن 2.00</td>
                        </tr>
                    </tbody>
                </table>

                <div className="text-[10px] mb-4">
                    <p>* تحتفظ الجامعة بحقها في تغيير الرسوم الدراسية خلال فترة الدراسة بعد موافقة مجلس الجامعات الخاصة.</p>
                    <p>* في حال تعديل الرسوم الدراسية من قبل مجلس الجامعات الخاصة - سوف يتم تطبيق التعديل على الرسوم الدراسية لجميع الطلاب .</p>
                    <p>* الرسوم الدراسية المذكورة أعلاه لاتشمل رسوم أو تكاليف الكتب والمواد الإستهلاكية والأدوات والخدمات</p>
                    <p>* إعادة المقررات الدراسية: تطبق الرسوم الدراسية كاملة على المقررات المكررة لأي سبب من الأسباب.</p>
                </div>

                {/* Section 3 */}
                <p className="font-bold text-red-700 underline mb-2">ثالثاً : الشروط العامة :</p>
                <div className="pr-4 mb-4">
                    <p>- الحد الأدنى من الساعات المعتمدة: يجب على الطالب التسجيل في 15 ساعة دراسية معتمدة على الأقل في كل فصل دراسي .</p>
                    <p>- الالتزام بالخطة الدراسية: يجب على الطالب إتباع الخطة الدراسية المقترحة للبرنامج ما لم يكونوا تحت الإنذار الأكاديمي.</p>
                    <p>- التكاليف الإضافية: جميع المواد والأدوات والأجهزة الإستهلاكية الخاصة باستخدام الطالب نفسه في المختبرات والعيادات التدريبية خلال فترة الدراسة في الجامعة تكون على نفقة الطالب الخاصة.</p>
                    <p>- تعديلات الرسوم: تحتفظ الجامعة بالحق في تعديل الرسوم بموافقة مجلس الجامعات الخاصة في الكويت ومجلس أمناء الجامعة.</p>
                </div>

                {/* Section 4 */}
                <p className="font-bold text-red-700 underline mb-2">رابعاً : عدم التزام الطالب بدفع الرسوم الدراسية :</p>
                <div className="pr-4 mb-4">
                    <p>يترتب على عدم دفع الرسوم الدراسية وفقاً للبند الثاني و في الوقت الزمني المحدد أعلاه إلغاء تسجيل الطالب في الفصل الدراسي الحالي أو القادم لحين سداد المديونية واتخاذ الجامعة الإجراءات القانونية اللازمة.</p>
                </div>

                {/* Section 5 */}
                <p className="font-bold text-red-700 underline mb-2">خامساً : سياسة الاسترداد :</p>
                <p className="font-bold underline mb-1">1- القواعد العامة:</p>
                <div className="pr-4 mb-4">
                    <p>- يتم احتساب الرسوم المستردة بناءً على مجمل الرسوم الدراسية المستحقة على الطالب ( لا تشمل الرسوم والمبالغ الغير قابلة للإسترداد).</p>
                    <p>- على الطالب الإلتزام بسياسة استرداد الرسوم.</p>
                    <p>- تنطبق سياسة الإسترداد على الرسوم الدراسية فقط و أي رسوم أخرى فهي غير قابلة للإسترداد.</p>
                    <p>- الطالب المفصول لأي سبب من الأسباب لا يسترد أي من الرسوم الدراسية أو الإضافية المدفوعة.</p>
                    <p>- في حالة إلغاء البرنامج الدراسي يحق للطالب استرداد الرسوم الدراسية المسددة للجامعة عن الفصل الدراسي الذي تم فيه الالغاء فقط.</p>
                    <p>- لا تسترد أي رسوم دراسية لطالب تم إلغاء قيده.</p>
                </div>

                <p className="font-bold text-red-700 underline mb-2">2- Course Drop - في حال سحب مقررات - لجميع الفصول الدراسية (ماعدا الفصل الصيفي) بعد السنة الدراسية الأولى :</p>
                <table className="w-full border-collapse border border-black mb-4 text-center">
                    <thead>
                        <tr className="bg-gray-400 font-bold">
                            <td className="border border-black p-1">الفترة الزمنية</td>
                            <td className="border border-black p-1">استرداد الرسوم (فصلي الخريف و الربيع)</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td className="border border-black p-1">خلال الأسبوع الأول من الفصل الدراسي</td><td className="border border-black p-1">استرداد 75% من المقرر المنسحب منه</td></tr>
                        <tr><td className="border border-black p-1">خلال الأسبوع الثاني من الفصل الدراسي</td><td className="border border-black p-1">استرداد 50% من المقرر المنسحب منه</td></tr>
                        <tr><td className="border border-black p-1">خلال الأسبوع الثالث من الفصل الدراسي</td><td className="border border-black p-1">استرداد 25% من المقرر المنسحب منه</td></tr>
                        <tr><td className="border border-black p-1">بعد الأسبوع الثالث من الفصل الدراسي</td><td className="border border-black p-1">لا يسترد أي مبلغ</td></tr>
                    </tbody>
                </table>

                {/* PAGE BREAK FOR PRINT */}
                <div className="print:page-break-after"></div>

                <p className="font-bold text-red-700 underline mb-2 mt-10">3- سياسة استرداد الرسوم في حال الانسحاب من المقرر الدراسي (الفصل الصيفي)</p>
                <table className="w-full border-collapse border border-black mb-4 text-center">
                    <thead>
                        <tr className="bg-gray-400 font-bold">
                            <td className="border border-black p-1">الفترة الزمنية</td>
                            <td className="border border-black p-1">استرداد الرسوم (الفصل الدراسي الصيفي)</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td className="border border-black p-1">أول 3 أيام (فترة الإضافة/الانسحاب) من الفصل الدراسي الصيفي</td><td className="border border-black p-1">استرداد 75% من المقرر المنسحب منه</td></tr>
                        <tr><td className="border border-black p-1">اليوم الرابع و الخامس من الفصل الدراسي الصيفي</td><td className="border border-black p-1">استرداد 50% من المقرر المنسحب منه</td></tr>
                        <tr><td className="border border-black p-1">خلال الأسبوع الثاني من الفصل الدراسي الصيفي</td><td className="border border-black p-1">استرداد 25% من المقرر المنسحب منه</td></tr>
                        <tr><td className="border border-black p-1">الأسبوع الثالث من الفصل الدراسي الصيفي وما بعده</td><td className="border border-black p-1">لا يسترد أي مبلغ</td></tr>
                    </tbody>
                </table>

                <p className="font-bold text-red-700 underline mb-2">4- سياسة استرداد الرسوم في حال الانسحاب من الجامعة</p>
                <table className="w-full border-collapse border border-black mb-4 text-center">
                    <thead>
                        <tr className="bg-gray-400 font-bold">
                            <td className="border border-black p-1">الفترة الزمنية</td>
                            <td className="border border-black p-1">استرداد الرسوم (فصلي الربيع و الخريف)</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td className="border border-black p-1">خلال الأسبوع الأول (فترة الإضافة/الانسحاب) للفصل الدراسي المنسحب منه</td><td className="border border-black p-1">استرداد 75% من الرسوم الدراسية للفصل الدراسي المنسحب منه</td></tr>
                        <tr><td className="border border-black p-1">خلال الأسبوع الثاني من الفصل الدراسي المنسحب منه</td><td className="border border-black p-1">استرداد 50% من الرسوم الدراسية للفصل الدراسي المنسحب منه</td></tr>
                        <tr><td className="border border-black p-1">بعد الأسبوع الثالث من الفصل الدراسي</td><td className="border border-black p-1">لا يسترد أي مبلغ</td></tr>
                    </tbody>
                </table>

                <p className="font-bold text-red-700 underline mb-2">5- سياسة استرداد الرسوم في حال تجميد الفصل الدراسي (وقف القيد):</p>
                <table className="w-full border-collapse border border-black mb-4 text-center">
                    <thead>
                        <tr className="bg-gray-400 font-bold">
                            <td className="border border-black p-1">الفترة الزمنية</td>
                            <td className="border border-black p-1">استرداد الرسوم (فصلي الربيع و الخريف)</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td className="border border-black p-1">تقديم طلب وقف قيد قبل 10 أيام عمل من أول يوم لبدء الدراسة في الفصل الدراسي</td><td className="border border-black p-1">استرداد 100% من الرسوم الدراسية للفصل الدراسي المراد إيقافه</td></tr>
                        <tr><td className="border border-black p-1">تقديم طلب وقف قيد في أي وقت بعد الوقت المحدد أعلاه</td><td className="border border-black p-1">لا يسترد أي مبلغ و يطالب بدفع الرسوم الدراسية كاملة</td></tr>
                    </tbody>
                </table>

                <p className="font-bold mb-4">ملاحظات هامة : بخصوص تعليق التسجيل (وقف القيد الدراسي):</p>
                <div className="pr-4 mb-6">
                    <p>- لايجوز للطالب وقف قيده قبل الإنتهاء من السنة الثانية من الدراسة بنجاح .</p>
                    <p>- يجب على الطالب الإلتزام بالمواعيد النهائية لوقف القيد بالدراسة المبينة في دليل الطالب وفق الشروط و الأحكام و وفق التقويم الأكاديمي للجامعة و بشرط موافقة مجلس الجامعات الخاصة لطلبة البعثات الداخلية وموافقة الجامعة الأمريكية للعلوم الطبية.</p>
                </div>

                {/* SIGNATURE BLOCK */}
                <div className="border-t-2 border-black pt-4">
                    <p className="font-bold mb-4 underline text-sm">إقرار بالعلم و الموافقة:</p>
                    <p className="font-bold mb-4">أقر بأنني اطلعت على السياسة المالية أعلاه و أوافق على جميع ما جاء من الشروط و البنود أعلاه والالتزام بها في حال قبولي</p>
                    
                    <div className="grid grid-cols-2 gap-y-4 text-sm mb-6">
                        <div>اسم الطالب: <span className="border-b border-black inline-block min-w-[200px] px-2">{formData.arabicFirstName?.value} {formData.arabicLastName?.value}</span></div>
                        <div>الرقم المدني للطالب: <span className="border-b border-black inline-block min-w-[200px] px-2 tracking-widest">{formData.civilId?.value}</span></div>
                        <div className="col-span-2">البريد الإلكتروني للطالب للتواصل: <span className="border-b border-black inline-block min-w-[300px] px-2">{formData.emailOne?.value}</span></div>
                        <div>توقيع الطالب: <span className="border-b border-black inline-block min-w-[200px]">____________________</span></div>
                        <div>التاريخ: <span className="border-b border-black inline-block min-w-[200px] px-2">{today}</span></div>
                    </div>

                    <p className="font-bold mb-4 text-justify">بصفتي ولي أمر الطالب اعلاه أقر بأنني اطلعت على السياسة المالية أعلاه وأوافق عليها وأتعهد بتسديد الرسوم الدراسية في تواريخ استحقاقها وألتزم باتباع جميع تعليمات وقوانين الجامعة ، وفي حال تغيير أي من البيانات أدناه أتعهد بإبلاغ قسم شؤون الطلبة بالجامعة.</p>

                    <div className="grid grid-cols-2 gap-y-4 text-sm">
                        <div>إسم ولي الأمر/ المقر : <span className="border-b border-black inline-block min-w-[200px] px-2">{formData.family?.arabicFatherName?.value}</span></div>
                        <div>الرقم المدني لولي الأمر: <span className="border-b border-black inline-block min-w-[200px] px-2 tracking-widest">{formData.family?.fatherCivilId?.value}</span></div>
                        <div className="col-span-2">العنوان: <span className="border-b border-black inline-block min-w-[400px] px-2">{formData.address?.area?.value} - {formData.address?.street?.value}</span></div>
                        <div>رقم الجوال / رقم الهاتف: <span className="border-b border-black inline-block min-w-[200px] px-2">{formData.family?.fatherMobile?.value}</span></div>
                        <div>البريد الإلكتروني: <span className="border-b border-black inline-block min-w-[200px] px-2">{formData.family?.fatherEmail?.value}</span></div>
                        <div>التوقيع : <span className="border-b border-black inline-block min-w-[200px]">____________________</span></div>
                        <div>التاريخ: <span className="border-b border-black inline-block min-w-[200px] px-2">{today}</span></div>
                    </div>
                </div>

                <div className="mt-10 flex justify-between text-blue-900 font-bold border-t border-gray-300 pt-2 print:border-none">
                    <p>Page 2 of 2</p>
                    <p>AUMS Official Application</p>
                </div>
            </div>
        </div>
    );
};

export default FinalPolicyPreview;
